import { Link, useLocation } from "react-router-dom";
import clsx from "clsx";
import { useUser } from "context/user-context";
export default function Sidebar({ menu, bottomButton }: { menu: any, bottomButton?: React.ReactNode }) {
	const location = useLocation();
	const { user } = useUser();

	const isReferent = !!user && user.est_referent;

	return (
		<aside className="md:w-52 border-r shadow-sm -my-4">
			<nav className="flex flex-col gap-2 py-2 h-full">
				{Object.values(menu).map((item: any, idx) => (
					((isReferent && item.isReferent) || (!item.isReferent)) && (
						<Link
							key={idx}
							to={`${item.path}`}
							className={clsx("px-4 py-2 hover:bg-BGheader",
								location.pathname === item.path && "bg-BGheader font-bold md:bg-transparent"
							)}>
							<>
								<div className='md:hidden h-6 w-6' dangerouslySetInnerHTML={{ __html: item.icon }} />
								<span className='hidden md:inline'>{item.name}</span>
							</>

						</Link>
					)
				))}
				{bottomButton && (
					<div className="mt-auto mx-auto mb-4">
						{bottomButton}
					</div>
				)}
			</nav>
		</aside>
	);
}
